export default __webpack_public_path__ + "static/media/chrome-logo.a50a7364.png";